import { client } from '@/common-utils/libraries/axios/axios';
import { PLANS } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationAddAllowedClients = (onSuccess, onError) => {
    return {
        mutationFn: ({ organizationId, planId, allowedClientsIds }) => {
            return client.post(replaceParameters(PLANS.COLLECTION_PLAN_ALLOWED_CLIENTS.url,
                {
                    organizationId: organizationId,
                    planId: planId
                }
            ), allowedClientsIds);
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationAddAllowedClients;